/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {StateDeclarationBuilder, AdnRouterHelperApi} from '../../routing/state-utils';
import {ALL_LAYOUTS} from './examples/all-layouts';
import {LayoutExampleContextActionsComponent} from './layout-example-context-actions.component';
import {emptyRouteView} from '../../common/directives/html/route-view-components';
import {LayoutExampleEditPageComponent} from './layout-example-edit-page.component';
import {getResourceItemTitleResolves, getResourceItemTitleView} from '../../base/default-item-title-view';
import {LayoutExampleRoutePageComponent} from './layout-example-route-page.component';


export function layoutExampleStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  const states = new StateDeclarationBuilder();
const rh = adnRouterHelper.createRouterHelper('layout-examples.layout-example', 'LayoutExample', 'app.adm', 'app/admin');
    
        const listState = rh.list({
          views: {
            'content@app': {component: LayoutExampleRoutePageComponent},
            'context@app': emptyRouteView()
          }
        });
        listState.resolve = {};
        states.add(rh.listPath(), listState);
    
        states.add(rh.itemPath(), rh.item({
          resolve: {
            ...getResourceItemTitleResolves('LayoutExample'),
            model: function($stateParams) {
              return ALL_LAYOUTS.find((layout) => layout.id === $stateParams.id);
            },
            readOnly: () => false
          },
          onEnter: function(model) {
            if (!model) {
              return adnRouterHelper.services.state().target('app.adm.layout-examples', null, {
                location: 'replace',
                inherit: false
              });
            }
          },
          views: {
            'content@app': {
              component: LayoutExampleEditPageComponent,
              bindings: {model: 'model', isNew: 'isNew'}
            },
            'context@app': {
              component: LayoutExampleContextActionsComponent,
              bindings: {model: 'model', readOnly: 'readOnly'}
            },
            'title@app': getResourceItemTitleView()
          }
        }, 'LayoutExample'));
  return states.build();
}
